import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'vendor_name', label: 'Vendor' },
  { key: 'invoice_number', label: 'Invoice #' },
  { key: 'invoice_date', label: 'Invoice Date' },
  { key: 'due_date', label: 'Due Date' },
  { key: 'balance', label: 'Balance', align: 'right', type: 'money' },
  { key: 'days_outstanding', label: 'Days Outstanding', align: 'right' },
  { key: 'bucket', label: 'Bucket' },
];

export function APAgeingReport() {
  return (
    <ReportView
      title="Accounts Payable Ageing"
      description="Every vendor invoice with an outstanding balance, bucketed by days overdue (current, 1-30, 31-60, 61-90, 91-120, 120+)."
      endpoint="/reports/procurement/ap-ageing"
      columns={COLUMNS}
      defaultSort="days_outstanding"
      xlsx
    />
  );
}
